import { Menu, Transition } from "@headlessui/react";
import React from "react";
import { Fragment, useEffect, useRef, useState } from "react";
import { FaAngleDown, FaCheck, FaList, FaUserAlt } from "react-icons/fa";
import { MdCheckBoxOutlineBlank } from "react-icons/md";
import { useSelector } from "react-redux";

export default (props) => {
  var { pickedRole, setPickedRole } = props.hook;

  const [selected, setselected] = useState();

  useEffect(() => {
    setselected(props.defaultvalue);
  }, [props.defaultvalue]);

useEffect(()=>{
 
props.onchange(selected)
},[selected])
  return (
    <>
      <Menu
        as="div"
        className={`relative my-2 ${props.maxwidth ? "min-w-[250px]" : ""}   ${
          props.fullwidth ? "min-w-full" : ""
        }`}
      >
        <div>
          {!props.notitle && (
            <p className="text-xs mb-2 ">
              {" "}
              {props.title} {props.tooltip}
            </p>
          )}
          <Menu.Button className="  px-4 py-2  flex text-sm bg-white shadow border rounded-[8px] w-full       ">
            <div className="flex flex-items items-center  w-full gap-4">
              <div className=" flex justify-between w-full  items-center p-1">
                <p className="text-xs font-light">{` Select weekends `}</p>
                <FaAngleDown color="#777777" />
              </div>

              <div className="flex items-center"></div>
            </div>
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="origin-top-left z-10 absolute left-0 mt-2 rounded-sm shadow-md p-1 bg-white  max-h-[300px]  w-full overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none">
            {props.list.map((item) => (
              <Menu.Item>
                {({ active }) => (
                  <p
                    onClick={() => {
                      if (selected.includes(item)) {
                        setselected((prev) => prev.filter((lk) => lk != item));
                      } else {
                        setselected((prev) => prev.concat([item]));
                      }
                    }}
                    className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
                  >
                    {selected.includes(item) ? (
                      <FaCheck className="text-primary inline " />
                    ) : (
                      <MdCheckBoxOutlineBlank className="inline  text-primary " />
                    )}
                    {item}
                  </p>
                )}
              </Menu.Item>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  );
};
